// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyBiPharmacy {
    static getAttributeTypeMap() {
        return PharmacyBiPharmacy.attributeTypeMap;
    }
}
PharmacyBiPharmacy.discriminator = undefined;
PharmacyBiPharmacy.additionalProperties = false;
PharmacyBiPharmacy.attributeTypeMap = [
    {
        "name": "ncpdpId",
        "baseName": "ncpdpId",
        "type": "string"
    },
    {
        "name": "npi",
        "baseName": "npi",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyBiPharmacy.js.map